import { render, staticRenderFns } from "./CommonCandleChart.vue?vue&type=template&id=37664be2&scoped=true"
import script from "./CommonCandleChart.vue?vue&type=script&lang=js"
export * from "./CommonCandleChart.vue?vue&type=script&lang=js"
import style0 from "./CommonCandleChart.vue?vue&type=style&index=0&id=37664be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37664be2",
  null
  
)

export default component.exports